export const isMac = () => {
  return typeof window != 'undefined' &&
    /Mac|iPod|iPhone|iPad/.test(window.navigator.platform)
}
